import { Header } from "@/components/layout/Header";
import { Hero } from "@/components/sections/Hero";
import { ImpactBar } from "@/components/sections/ImpactBar";
import { ExecutiveEndorsements } from "@/components/sections/ExecutiveEndorsements";
import { About } from "@/components/sections/About";
import { CaseStudies } from "@/components/sections/CaseStudies";
// import { Tools } from "@/components/sections/Tools"; // Hidden for now
import { Insights } from "@/components/sections/Insights";
import { Contact } from "@/components/sections/Contact";
import { Footer } from "@/components/layout/Footer";
import { SEO } from "@/components/SEO";
import { StructuredData } from "@/components/StructuredData";

const Index = () => {
  return (
    <div className="min-h-screen bg-background">
      <SEO
        title="Digital Transformation Executive"
        description="Senior Digital Transformation Executive driving $16M+ in annual impact through Product Strategy, AI Innovation, and Operational Excellence in Healthcare & MarTech."
        image="/og-image.png"
        tags={["digital transformation", "healthcare technology", "MarTech", "AI innovation", "product strategy", "operational excellence"]}
      />
      <StructuredData type="Person" />
      <StructuredData type="WebSite" />
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-[100] focus:px-4 focus:py-2 focus:bg-primary focus:text-primary-foreground focus:rounded-md focus:outline-none focus:ring-2 focus:ring-ring"
      >
        Skip to main content
      </a>
      <Header />
      <main id="main-content" tabIndex={-1} className="outline-none">
        <Hero />
        <ImpactBar />
        <ExecutiveEndorsements />
        <About />
        <CaseStudies />
        {/* <Tools /> */}{/* Hidden for now */}
        <Insights />
        <Contact />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
